import IMask from 'imask';
import { Fancybox } from '@fancyapps/ui';

function checkValidityName(name) {
    const regexName = /^[A-zА-яЁё\-'\s]{2,64}$/;
    return regexName.test(name);
}

function checkValidityPhone(tel) {
    const regexTel = /^\+\d \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
    return regexTel.test(tel);
}

function checkValidityEmail(email) {
    const regexEmail = /^[A-z0-9._%+-]{2,}@[A-z0-9.-]{2,}\.[A-z]{2,}$/;
    return regexEmail.test(email);
}

function checkValiditySelect(select) {
    return select !== "" ? true : false;
}

function checkValidityCheckbox(checkbox) {
    if(!checkbox){
        return true;
    }
    return checkbox.checked;
}

function validateInputField(element, validationFunction) {
    if (!element) {
        return true;
    }
    let isValid;
    switch(element.type){
        case 'checkbox':
            isValid = validationFunction(element);
            break;
        default:
            const value = element.value.trim();
            isValid = validationFunction(value);
    }
    element.classList.remove('invalid');
    return isValid;
}
// document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll("form.js-validation").forEach(function (form) {
        const formType = form.dataset.formType?.trim() || 'normal';
        console.debug(form, formType);
        // To counter IMask NOT checking element for existence
        const inputTel = form.querySelector('.input_tel');
        const inputEmail = form.querySelector('.input_email');
        if(inputTel){
            IMask(inputTel, {
                mask: '+7 (000) 000-00-00',
                lazy: false,
            });
        }
        if(inputEmail){
            IMask(inputEmail, {
                mask: /^([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]{0,64}(@)?([a-zA-Z0-9-]{0,255}(\.[a-zA-Z0-9-]{0,63})?)?)?$/
            });
        }

        let isFirstSubmit = true;
        const buttonSubmit = form.querySelector('button.button_submit');

        const formFields = {
            name: {
                element: form.querySelector('.input_name') ?? null,
                isValid: validateInputField(form.querySelector('.input_name'), checkValidityName),
                validationFunction: checkValidityName
            },
            tel: {
                element: form.querySelector('.input_tel') ?? null,
                isValid: validateInputField(form.querySelector('.input_tel'), checkValidityPhone),
                validationFunction: checkValidityPhone
            },
            email: {
                element: form.querySelector('.input_email') ?? null,
                isValid: validateInputField(form.querySelector('.input_email'), checkValidityEmail),
                validationFunction: checkValidityEmail
            },
            consent: {
                element: form.querySelector('.input_consent') ?? null,
                isValid: validateInputField(form.querySelector('.input_consent'), checkValidityCheckbox),
                validationFunction: checkValidityCheckbox
            },
            promo: {
                element: form.querySelector('.input_promo') ?? null,
                isValid: validateInputField(form.querySelector('.input_promo'), checkValidityCheckbox),
                validationFunction: checkValidityCheckbox
            },
            select: {
                element: form.querySelector('.input_select') ?? null,
                isValid: validateInputField(form.querySelector('.input_select'), checkValiditySelect),
                validationFunction: checkValiditySelect
            }
        };
        function checkValidityStateAll(assignClasses = false){
            let allFieldsValid = true;
            Object.values(formFields).forEach(field => {
                if(field.element){
                    if (!field.isValid) {
                        allFieldsValid = false;
                        if (assignClasses) {
                            field.element.classList.add('invalid');
                        }
                    }
                }
            });
            return allFieldsValid; 
        }
        function updateSubmitButton() {
            if(!buttonSubmit){
                return;
            }
            if (isFirstSubmit) {
                buttonSubmit.disabled = false;
            } else {
                buttonSubmit.disabled = !checkValidityStateAll;
            }
        }
        updateSubmitButton(checkValidityStateAll());

        Object.values(formFields).forEach(function(field){
            if(field.element){
                function fieldProcessing(){
                    field.isValid = validateInputField(field.element, field.validationFunction);
                    updateSubmitButton(checkValidityStateAll());
                    field.element.classList.remove('invalid');
                }
                field.element.addEventListener('input', fieldProcessing);
                field.element.addEventListener('change', fieldProcessing);
                field.element.addEventListener('blur', fieldProcessing);
            }
        })

        function addWaitingDots() {
            if (form.querySelector('.loading')) {
                return;
            }
            const template = document.querySelector('#loading-template');
            const clone = template.content.firstElementChild.cloneNode(true);
            clone.style.display = "none";
            buttonSubmit.appendChild(clone);
            // fadeIn
            requestAnimationFrame(() => {
                clone.style.opacity = 0;
                clone.style.display = "";
                clone.style.transition = "opacity 200ms";
                requestAnimationFrame(() => {
                    clone.style.opacity = 1;
                });
            });
        }
        function removeWaitingDots() {
            const waitingDots = buttonSubmit.querySelector(".loading");
            if (!waitingDots) return;

            waitingDots.style.transition = "opacity 200ms";
            waitingDots.style.opacity = 0;

            waitingDots.addEventListener("transitionend", () => {
                waitingDots.remove();
            }, { once: true });
        }

        form.addEventListener('submit', function (event) {
            event.preventDefault();
            isFirstSubmit = false;
            buttonSubmit.disabled = true;
            if (!checkValidityStateAll(true)) {
                console.debug('Form validity failed');
                buttonSubmit.disabled = false;
                return;
            }
            const formData = new FormData(form);
            console.debug('Form submit triggered');
            console.debug('FormData snapshot:', Array.from(formData.entries()));
            let fetchSuccess = false;
            let redirect = null;
            addWaitingDots();
            switch(formType){
                case "minicart":
                    formData.append('action', 'submit_minicart_data');
                    fetch('/wp-admin/admin-ajax.php', {
                        method: 'POST',
                        body: formData,
                        credentials: 'same-origin'
                    })
                    .then(function (response) {
                        console.debug('Fetch attempted, raw response:', response);
                        return response.json().catch(() => {
                            console.debug('Response was not JSON, returning raw text instead');
                            return response.text();
                        });
                    })
                    .then(function (data) {
                        console.debug('Fetch resolved, parsed data:', data);
                        switch (data.success) {
                            case false:
                                console.debug('Server reported failure, errors:', data.errors || []);
                                break;
                            case true:
                                console.debug('Server reported success');
                                fetchSuccess = true;
                                redirect = data.data.redirect;
                                return;
                            default:
                                console.debug('Server sent unknown status:', data.status);
                        }
                    })
                    .catch(function (error) {
                        console.debug('Fetch failed:', error);
                    })
                    .finally(function () {
                        if(fetchSuccess){
                            console.debug('Fetch done successfully');
                            console.debug(`Will redirect to ${redirect}`);
                            if(redirect){
                                window.location.href = redirect;
                            }
                            // removeWaitingDots();
                            // buttonSubmit.disabled = false;
                            // document.getElementById('mini-cart').classList.add('sent');
                            // Fancybox.close();
                            // Fancybox.show([{ src: '#modal-thanks', type: 'inline', dragToClose: false, closeButton: false, autoFocus: false,}]);
                        } else{
                            console.debug('Fetch done and probably failed');
                            buttonSubmit.disabled = false;
                            removeWaitingDots();
                        }
                    });
                    break;
                default: 
                    formData.append('action', 'submit_form');
                    fetch('/wp-admin/admin-ajax.php', {
                        method: 'POST',
                        body: formData,
                        credentials: 'same-origin'
                    })
                    .then(function (response) {
                        console.debug('Fetch attempted, raw response:', response);
                        return response.json().catch(() => {
                            console.debug('Response was not JSON, returning raw text instead');
                            return response.text();
                        });
                    })
                    .then(function (data) {
                        console.debug('Fetch resolved, parsed data:', data);
                        switch (data.success) {
                            case false:
                                console.debug('Server reported failure, errors:', data.errors || []);
                                fetchSuccess = data.success;
                                break;
                            case true:
                                console.debug('Server reported success');
                                fetchSuccess = data.success;
                                redirect = data.data.redirect;
                                return;
                            default:
                                console.debug('Server sent unknown status:', data.status);
                        }
                    })
                    .catch(function (error) {
                        console.debug('Fetch failed:', error);
                    })
                    .finally(function () {
                        if(fetchSuccess){
                            console.debug('Fetch done successfully');
                            console.debug(`Will redirect to ${redirect}`);
                            if(redirect){
                                window.location.href = redirect;
                            }
                        } else{
                            console.debug('Fetch done and probably failed');
                            buttonSubmit.disabled = false;
                            removeWaitingDots();
                        }
                    });
            }
        });

    });
// });